import useReveal from '../../hooks/useReveal.js';
import Eyebrow from './Eyebrow.jsx';

/**
 * SectionHead — standard section header block.
 *
 * Props:
 *   eyebrow: string (required)
 *   eyebrowTone: 'default' | 'purple'
 *   heading: ReactNode — main h2; may contain <span className="text-gradient-accent"> for highlight
 *   description: string
 *   maxWidth: 'default' | 'narrow'
 */
export default function SectionHead({
  eyebrow,
  eyebrowTone = 'default',
  heading,
  description,
  maxWidth = 'default',
}) {
  const ref = useReveal();
  const maxCls = maxWidth === 'narrow' ? 'max-w-[560px]' : 'max-w-[720px]';

  return (
    <div ref={ref} className={`reveal mb-14 ${maxCls}`}>
      <Eyebrow tone={eyebrowTone}>{eyebrow}</Eyebrow>
      <h2 className="mt-4 mb-4 text-display-lg text-ink-50">{heading}</h2>
      {description && (
        <p className="text-body-lg text-ink-200 m-0">{description}</p>
      )}
    </div>
  );
}
